// qrPlatba.js — QR kód na úhradu došlej FA, JEDNO miesto pre celý Matrix (ústava 0.J, 14.4).
// qr_lokalne_v1 (18. 10. 2026, kúsok 3 pre-flightu Office bez iKROSu, GO Mirka): QR sa kreslí lokálne
// (qrcode-generator, rovnako ako nálepky požičovne) — IBAN, suma a VS už neodchádzajú na api.qrserver.com.
// Formát EPC/SEPA (BCD 002) — Mirko 9. 6. 2026: bysquare jeho banke nefungoval, EPC zo starého Matrixu áno.
import qrcodegen from 'qrcode-generator'

const cisteIban = (iban) => String(iban || '').replace(/\s/g, '').toUpperCase()
export const platnySkIban = (iban) => /^SK\d{22}$/.test(cisteIban(iban))

// Dátové pole EPC QR (SEPA Credit Transfer). Vracia null bez platného SK IBANu.
export function epcPayload({ iban, suma, prijemca, vs, poznamka }) {
  const ib = cisteIban(iban)
  if (!platnySkIban(ib)) return null
  const amount = (Math.round((Number(suma) || 0) * 100) / 100).toFixed(2)
  const name = String(prijemca || '').replace(/[\r\n]/g, ' ').slice(0, 70)
  const ref = String(vs || '').replace(/\D/g, '').slice(0, 10)
  const note = String(poznamka || '').replace(/[\r\n]/g, ' ').slice(0, 140)
  return ['BCD', '002', '1', 'SCT', '', '', name, ib, 'EUR' + amount, '', ref ? 'VS' + ref : '', '', note].join('\n')
}

// SVG ako data: URL — vloží sa priamo do <img src>, nič sa nesťahuje zvonka.
export function qrDataUrl(payload, farba = '#111111') {
  if (!payload) return null
  const qr = qrcodegen(0, 'M')
  qr.addData(payload)
  qr.make()
  const n = qr.getModuleCount()
  let d = ''
  for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c} ${r}h1v1h-1z`
  const m = 2   // tichá zóna
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${-m} ${-m} ${n + 2 * m} ${n + 2 * m}" shape-rendering="crispEdges"><rect x="${-m}" y="${-m}" width="${n + 2 * m}" height="${n + 2 * m}" fill="#ffffff"/><path fill="${farba}" d="${d}"/></svg>`
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
}

// Hotový obrázok QR na úhradu jednej FA alebo skupiny FA (rovnaký IBAN).
export function qrUhrada({ iban, suma, prijemca, vs, poznamka }) {
  return qrDataUrl(epcPayload({ iban, suma, prijemca, vs, poznamka }))
}
